import { render, staticRenderFns } from "./FcTextLeft.vue?vue&type=template&id=35192b60&scoped=true&"
import script from "./FcTextLeft.vue?vue&type=script&lang=js&"
export * from "./FcTextLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35192b60",
  null
  
)

export default component.exports